import {Component} from '@angular/core';

@Component({
    selector: 'app-balances',
    templateUrl: './balances.component.html',
    standalone: false
})
export class BalancesComponent {}
